import ApiService from '@/services/core/api.service'

const CommentService = {
  async get (payment, params = {}) {
    return ApiService.get(`user/payment-requests/${payment}/comments`, { params })
  },

  async post (payment, payload) {
    return ApiService.post(`user/payment-requests/${payment}/comments`, payload)
  },

  async put (payment, payload) {
    return ApiService.put(`user/payment-requests/${payment}/comments/${payload.id}`, payload)
  },

  async delete (payment, payload) {
    return ApiService.delete(`user/payment-requests/${payment}/comments/${payload.id}`, {
      data: payload
    })
  }
}

export default CommentService
